const API_URL = process.env.REACT_APP_API_URL + "/api/health";

export async function checkHealth() {
  try {
    const res = await fetch(API_URL);
    if (!res.ok) return false;
    const data = await res.json();
    return data.status === "ok";
  } catch (err) {
    return false;
  }
}
